/* eslint max-len: 0 */
import gql from 'graphql-tag';

export const RegisterUser = gql`
  mutation RegisterUser($input: DriverRegistrationInput!) {
    postDriverRegistration(input: $input) {
      PK
      SK
      CARRIERID
      DriverStatus
      FirstName
      LastActionDate
      LastActionType
      LastName
    }
  }
`;

/**
 * @param {*} graphClient AWS Graphclient
 * @param {*} userDetails - contains user detail values
 */
export const postRegistration = async (graphClient, userDetails) => {
  try {
    let response = await graphClient.mutate({
      mutation: RegisterUser,
      variables: {
        input: {
          email: userDetails.Email,
          driverID: userDetails.DriverId,
          carrierID: userDetails.CarrierId,
          firstName: userDetails.FirstName,
          lastName: userDetails.LastName,
        }
      },
    });
    return {data:response.data.postDriverRegistration ? response.data.postDriverRegistration : null};
  } catch (e) {
    console.log('Error! while register: postRegistration', e);
    return {error:e.message};
  }
};